var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4V19.9998H19.9999V19.435V4H4ZM18.8705 18.8703H5.1294V7.48197H18.8705V18.8703Z",
    fill: "#081E56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5528 9.25H6.44702V12.2726H17.5528V9.25Z",
    fill: "#081E56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5527 13.6836H13.2234V17.4013H17.5527V13.6836Z",
    fill: "#081E56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5292 13.7402H6.44702V14.3049H11.5292V13.7402Z",
    fill: "#081E56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5292 16.7812H6.44702V17.346H11.5292V16.7812Z",
    fill: "#081E56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5292 15.2607H6.44702V15.8255H11.5292V15.2607Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/Design.efe61a943b66dccf09a16170bfe5e8bd.svg";
export { ForwardRef as ReactComponent };